import adjustWorkTimes from './rules/adjustWorkTimes';
import postedSchedules from './rules/postedSchedules';
import liveSchedules from './rules/liveSchedules';
import mySchedule from './rules/mySchedule';
import sameResource from './rules/sameResource';
import assignments from './rules/assignments'
import editMode from './rules/editMode';
import addTour from './rules/addTour';
import changeDayType from './rules/changeDayType';
import isApprover from './rules/isApprover';
import editTour from './rules/editTour';
import addDayTypeRequest from './rules/addDayTypeRequest';
import editDayTypeRequest from './rules/editDayTypeRequest';
import removeDayTypeRequest from './rules/removeDayTypeRequest';
import changeAssignmentsResource from './rules/changeAssignmentsResource';
import changeAbsencesResource from './rules/changeAbsencesResource';
import addAssignment from './rules/addAssignment';
import addAssignmentViewPrices from './rules/addAssignmentViewPrices';
import addAssignmentViewActivityType from './rules/addAssignmentViewActivityType';
import addAssignmentEditActivityType from './rules/addAssignmentEditActivityType';
import addAssignmentViewSalaryLevel from './rules/addAssignmentViewSalaryLevel';
import addAssignmentViewAssignmentStatus from './rules/addAssignmentViewAssignmentStatus';
import addAssignmentEditAssignmentStatus from './rules/addAssignmentEditAssignmentStatus';
import addAssignmentViewDescription from './rules/addAssignmentViewDescription';
import addAssignmentEditDescription from './rules/addAssignmentEditDescription';
import deleteAssignment from './rules/deleteAssignment';
import deleteRequest from './rules/deleteRequest';
import viewActivityType from './rules/viewActivityType';
import viewTourSalaryLevel from './rules/viewTourSalaryLevel';
import viewTourSalaryLevelUpgrade from './rules/viewTourSalaryLevelUpgrade';
import viewAssignmentSalaryLevelAndUpgrade from './rules/viewAssignmentSalaryLevelAndUpgrade';
import approveTours from './rules/approveTours';
import approveJobElements from './rules/approveJobElements';
import submitApprovals from './rules/submitApprovals';
import resourceInfo from './rules/resourceInfo';
import resourceInfoSSO from './rules/resourceInfoSSO';
import approvals from './rules/approvals';
import viewCalendar from './rules/viewCalendar';
import editStatus from './rules/editStatus';
import viewStatus from './rules/viewStatus';
import previousPostings from './rules/previousPostings';

const authLogic = {
  adjustWorkTimes,
  postedSchedules,
  previousPostings,
  liveSchedules,
  mySchedule,
  sameResource, // can probably delete
  assignments,
  editMode,
  addTour,
  changeDayType,
  isApprover,
  editTour,
  addDayTypeRequest,
  editDayTypeRequest,
  removeDayTypeRequest,
  changeAssignmentsResource,
  changeAbsencesResource,
  addAssignment,
  addAssignmentViewPrices,
  addAssignmentViewActivityType,
  addAssignmentEditActivityType,
  addAssignmentViewSalaryLevel,
  addAssignmentViewAssignmentStatus,
  addAssignmentEditAssignmentStatus,
  addAssignmentViewDescription,
  addAssignmentEditDescription,
  deleteAssignment,
  deleteRequest,
  viewActivityType,
  viewTourSalaryLevel,
  viewTourSalaryLevelUpgrade,
  viewAssignmentSalaryLevelAndUpgrade,
  approveTours,
  approveJobElements,
  submitApprovals,
  resourceInfo,
  resourceInfoSSO,
  approvals,
  viewCalendar,
  editStatus,
  viewStatus
};


export default authLogic;



// WEBPACK FOOTER //
// ./src/AuthLogic/index.js